import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import { TreeView, TreeViewRef } from 'devextreme-react/tree-view';
import { useTranslation } from 'react-i18next';
import { getNavigation } from '../../app-navigation'; // Import the function
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './SideNavigationMenu.scss';
import type { SideNavigationMenuProps } from '../../types';
import * as events from 'devextreme/events';
import { useLocation } from 'react-router-dom';

export default function SideNavigationMenu(props: React.PropsWithChildren<SideNavigationMenuProps>) {
  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const { t } = useTranslation(); // Use the translation hook
  const location = useLocation();
  const { isLarge } = useScreenSize();


  // function normalizePath() {
  //   return navigation.map((item) => (
  //     { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
  //   ))
  // }

  // const items = useMemo(
  //   normalizePath,
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );

  //const { navigationData: { currentPath } } = useNavigation();

  const items = useMemo(() => getNavigation(t, isLarge), [t, isLarge]); // Depend on `t` so it updates with language change


  const treeViewRef = useRef<TreeViewRef>(null);
  const wrapperRef = useRef<HTMLDivElement>();
  const getWrapperRef = useCallback((element: HTMLDivElement) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', (e: React.PointerEvent) => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance();
    if (!treeView) {
      return;
    }

    // console.log(location.pathname); // Ottieni solo il percorso, es. '/home'

    if (location.pathname !== undefined) {
      treeView.selectItem(location.pathname);
      treeView.expandItem(location.pathname);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [location.pathname, compactMode]);

  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />
      </div>
    </div>
  );
}
